import { rootApi } from '../rootApi';

/**
 * LMS Eğitmen Atamaları — `/v1.0/LmsTrainingInstructor`.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 1.md §4.
 *
 * Atama/güncelleme/silme, ilgili eğitimin katalog kaydındaki `instructorsCount` değerini
 * backend'de yeniden hesaplattığı için `LmsTrainingCatalog` tag'i de invalidate edilir.
 */
export const lmsTrainingInstructorApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTrainingInstructors: builder.query({
            query: ({ trainingId, trainingCode, userId, userFullName, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsTrainingInstructor/GetList',
                method: 'POST',
                body: {
                    trainingId: trainingId ?? null,
                    trainingCode: trainingCode || null,
                    userId: userId ?? null,
                    userFullName: userFullName || null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTrainingInstructor']
        }),

        getLmsTrainingInstructorById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingInstructor/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingInstructor']
        }),

        addLmsTrainingInstructor: builder.mutation({
            query: ({ userId, trainingId }) => ({
                url: 'v1/LmsTrainingInstructor/Add',
                method: 'POST',
                body: { userId, trainingId }
            }),
            invalidatesTags: ['LmsTrainingInstructor', 'LmsTrainingCatalog']
        }),

        updateLmsTrainingInstructor: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingInstructor/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingInstructor', 'LmsTrainingCatalog']
        }),

        deleteLmsTrainingInstructor: builder.mutation({
            query: (id) => ({
                url: `v1/LmsTrainingInstructor/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsTrainingInstructor', 'LmsTrainingCatalog']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTrainingInstructorsQuery,
    useGetLmsTrainingInstructorByIdQuery,
    useAddLmsTrainingInstructorMutation,
    useUpdateLmsTrainingInstructorMutation,
    useDeleteLmsTrainingInstructorMutation
} = lmsTrainingInstructorApi;
